var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAmex(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 24,
    viewBox: "0 0 35 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.250001,
    y: 0.24997,
    width: 34.5001,
    height: 23.5,
    rx: 2.75001,
    fill: "#1F72CD",
    stroke: "#D9D9D9",
    strokeWidth: 0.500001
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.27444 8.50012L2.99976 15.7469H6.92001L7.406 14.5914H8.51689L9.00288 15.7469H13.318V14.865L13.7025 15.7469H15.9346L16.3191 14.8464V15.7469H25.2933L26.3845 14.6215L27.4063 15.7469L32.0157 15.7562L28.7306 12.1437L32.0157 8.50012H27.4778L26.4156 9.60475L25.426 8.50012H15.6632L14.8248 10.3706L13.9668 8.50012H10.0548V9.35198L9.61958 8.50012H6.27444ZM19.6755 9.52916H24.8289L26.4051 11.2317L28.0321 9.52916H29.6083L27.2134 12.1427L29.6083 14.7261H27.9606L26.3844 13.0038L24.7491 14.7261H19.6755V9.52916ZM20.948 11.555V10.6058V10.6049H24.1636L25.5667 12.123L24.1014 13.6494H20.948V12.6131H23.7594V11.555H20.948ZM7.03301 9.52916H8.94392L11.116 14.4432V9.52916H13.2093L14.887 13.0525L16.4332 9.52916H18.5161V14.7292H17.2487L17.2384 10.6545L15.3906 14.7292H14.2569L12.3989 10.6545V14.7292H9.79157L9.29728 13.5634H6.6268L6.13353 14.7282H4.73657L7.03301 9.52916ZM7.08252 12.4856L7.96234 10.4088L8.84113 12.4856H7.08252Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmex);
export default __webpack_public_path__ + "static/media/Amex.149c90598865b0942a3d11cfd83af674.svg";
export { ForwardRef as ReactComponent };